export default __webpack_public_path__ + "67df845bb064a1f49d8f053cfed912c9.png";